import React from 'react';
import { Phone, Mail, CreditCard, MapPin } from 'lucide-react';
import { BiRupee } from 'react-icons/bi';
import { BsPerson } from 'react-icons/bs';

const AccountInfo = () => {
   return (
      <>
         <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl border border-slate-800 p-4">
            <h3 className="text-lg font-semibold text-white mb-3">Business Information</h3>

            <div className="space-y-4">
               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* Phone Number */}
                  <div className="flex items-center gap-4 px-3 py-2 bg-slate-800/30 rounded-xl border border-slate-700/50 hover:border-slate-600/50 transition-colors">
                     <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-emerald-500/10 border border-emerald-500/20">
                        <Phone className="w-5 h-5 text-emerald-400" />
                     </div>
                     <div className="flex-1">
                        <p className="text-xs text-slate-400 mb-1">Phone Number</p>
                        <p className="text-sm font-medium text-white">2222222222</p>
                     </div>
                  </div>
                  <div className="flex items-center gap-4 px-3 py-2 bg-slate-800/30 rounded-xl border border-slate-700/50 hover:border-slate-600/50 transition-colors">
                     <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-rose-500/10 border border-rose-500/20">
                        <BiRupee className="w-5 h-5 text-rose-400" />
                     </div>
                     <div className="flex-1">
                        <p className="text-xs text-slate-400 mb-1">Amount</p>
                        <p className="text-sm font-medium text-white">100564</p>
                     </div>
                  </div>
               </div>

               {/* Additional ID */}
               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex items-center gap-4 px-3 py-2 bg-slate-800/30 rounded-xl border border-slate-700/50 hover:border-slate-600/50 transition-colors">
                     <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-cyan-500/10 border border-cyan-500/20">
                        <Mail className="w-5 h-5 text-cyan-400" />
                     </div>
                     <div className="flex-1">
                        <p className="text-xs text-slate-400 mb-1">Email</p>
                        <p className="text-sm font-medium text-white">example@gmail.com</p>
                     </div>
                  </div>
                  <div className="flex items-center gap-4 px-3 py-2 bg-slate-800/30 rounded-xl border border-slate-700/50 hover:border-slate-600/50 transition-colors">
                     <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-sky-500/10 border border-sky-500/20">
                        <BsPerson className="w-5 h-5 text-sky-400" />
                     </div>
                     <div className="flex-1">
                        <p className="text-xs text-slate-400 mb-1">Broker Name</p>
                        <p className="text-sm font-medium text-white">Test Name</p>
                     </div>
                  </div>
               </div>
               {/* Account/License Info */}
               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {/* GST/Account Number */}
                  <div className="flex items-center gap-4 px-3 py-2 bg-slate-800/30 rounded-xl border border-slate-700/50 hover:border-slate-600/50 transition-colors">
                     <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-purple-500/10 border border-purple-500/20">
                        <CreditCard className="w-5 h-5 text-purple-400" />
                     </div>
                     <div className="flex-1">
                        <p className="text-xs text-slate-400 mb-1">GST Number</p>
                        <p className="text-sm font-medium text-white">BJUPB4388N</p>
                     </div>
                  </div>

                  {/* Transaction/Code */}
                  <div className="flex items-center gap-4 px-3 py-2 bg-slate-800/30 rounded-xl border border-slate-700/50 hover:border-slate-600/50 transition-colors">
                     <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-amber-500/10 border border-amber-500/20">
                        <CreditCard className="w-5 h-5 text-amber-400" />
                     </div>
                     <div className="flex-1">
                        <p className="text-xs text-slate-400 mb-1">PAN Number</p>
                        <p className="text-sm font-medium text-white">BJUPB4388N</p>
                     </div>
                  </div>
               </div>

               {/* Address */}
               <div className="flex items-start gap-4 px-3 py-2 bg-slate-800/30 rounded-xl border border-slate-700/50 hover:border-slate-600/50 transition-colors">
                  <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-blue-500/10 border border-blue-500/20 flex-shrink-0">
                     <MapPin className="w-5 h-5 text-blue-400" />
                  </div>
                  <div className="flex-1 min-w-0">
                     <p className="text-xs text-slate-400 mb-1">Address</p>
                     <p className="text-sm font-medium text-white break-words">
                        3rd Floor 336, Avadh Arena VIP Road, Vesu
                     </p>
                  </div>
               </div>
               <div className="flex items-start gap-4 px-3 py-2 bg-slate-800/30 rounded-xl border border-slate-700/50 hover:border-slate-600/50 transition-colors">
                  <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-blue-500/10 border border-blue-500/20 flex-shrink-0">
                     <MapPin className="w-5 h-5 text-blue-400" />
                  </div>
                  <div className="flex-1 min-w-0">
                     <p className="text-xs text-slate-400 mb-1">Address</p>
                     <p className="text-sm font-medium text-white break-words">
                        3rd Floor 336, Avadh Arena VIP Road, Vesu
                     </p>
                  </div>
               </div>
            </div>
         </div>
      </>
   );
};

export default AccountInfo;
